import "./ProjectTreeRowLsr.css";

import { useSelector } from "react-redux";

import { getUserPermissions } from "slices/auth";
import { getUserSettingsLsrStatus } from "slices/user_adv";

import ProjectTreeHandleValidator from "./ProjectTreeHandleValidator";
import CircleStatus from "./ProjectTreeRowCircleStatus";
import ProjectTreeRowComment from "./ProjectTreeRowComment";
import ProjectTreeRowName from "./ProjectTreeRowName";
import ProjectTreeRowWrapper from "./ProjectTreeRowWrapper";
import useTreeRow from "./useTreeRow";

const ProjectTreeRowLsr = ({ rowObj, callbacks }) => {
	const paddingLeft = 45;
	const hasParent = rowObj._children?.length > 0;
	const userPermissions = useSelector(getUserPermissions);
	const lsrStatusUsage = useSelector(getUserSettingsLsrStatus);

	const { getStyle } = useTreeRow();

	const autoStatusStyle = {};
	if (rowObj.double_is_winner === false) autoStatusStyle.paddingLeft = 15;

	return (
		<>
			<div
				className="project-tree-row"
				style={{ paddingLeft: paddingLeft, width: `calc(100% - ${paddingLeft + 3}px)`, ...getStyle({ rowObj }) }}
			>
				<span className="auto-status" style={autoStatusStyle}>
					<CircleStatus rowObj={rowObj} />
				</span>
				{userPermissions?.is_expert && rowObj.double_is_winner !== false && lsrStatusUsage === true && (
					<ProjectTreeHandleValidator rowObj={rowObj} />
				)}
				<ProjectTreeRowName rowObj={rowObj} fontSize={13} callbacks={callbacks} />
				{rowObj?._has_comment && <ProjectTreeRowComment rowObj={rowObj} callbacks={callbacks} />}
			</div>
			{hasParent === true &&
				rowObj.childs_visible !== false &&
				rowObj._children?.map((chObj) => {
					return <ProjectTreeRowWrapper key={chObj.key} rowObj={chObj} callbacks={callbacks} />;
				})}
		</>
	);
};

export default ProjectTreeRowLsr;
